import React, { useState } from "react";
// import "./../../About/OurStory/OurStory.css";
import "./AccountClosureOption.css";
import { Container, Col, Row } from "react-bootstrap";
import axios from "axios";
import { useSelector, useDispatch } from 'react-redux';
import { userSelector, clearState, fetchUserBytoken } from '../../features/User/UserSlice';


function AccountClosureOption() {
  const [demat_account, setDemat_account] = useState('');
  const [trading_account, setTrading_account] = useState('');
  const [demat_trading_both_account, setDemat_trading_both_account] = useState('');
  const [reason_for_closing, setReason_for_closing] = useState('');
  const { email} = useSelector(userSelector);
  const handleDematAccount = event => {
    setDemat_account(event.target.checked);
  };
  const handleTradingAccount = event => {
    setTrading_account(event.target.checked);
  };
  const handleBothAccount = event => {
    setDemat_trading_both_account(event.target.checked);
  };
  const handleReasonCloseAccount = event => {
    setReason_for_closing(event.target.value);
  };

  const clicksubmitaccount = async () => {

    var from_data_account = {
      "demat_account": demat_account, "trading_account": trading_account, "demat_trading_both_account": demat_trading_both_account,
      "email_id": email, "reason_for_closing": reason_for_closing, "upd_file": false
    }
    axios.post("/api/Login/AccountClosure", from_data_account)
      .then(function (response) {
        if (response.data.success === false) {
          return false;
        }
        else{
          window.location.href = "/AccountClosureForm";
        }
      })
      .catch(function (response) {

      });
  };


  return (
    <>
      <div className="AccountClosureOption_page">
        <section className="our-story-block disclaimer">
          <Container>
            <Row>
              <Col md={{ span: 12, offset: 0 }}>
                <div className="our-story-inner arrow-main">
                  <h2 className="text-center">Please Select the Option </h2>
                  <div className="accountClosure_form">
                    <h3>Which Account do you want to close?  </h3>
                    <form action="/AccountClosureForm" >
                      <div className="form-row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <div className="custom-control custom-checkbox">
                              <input type="checkbox" className="custom-control-input" id="Demat-Account" name="example1" value={demat_account} onChange={handleDematAccount}></input>
                              <label className="custom-control-label" htmlFor="Demat-Account">Demat Account</label>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="custom-control custom-checkbox">
                            <input type="checkbox" className="custom-control-input" id="Trading-Account" name="Trading-Account" value={trading_account} onChange={handleTradingAccount}></input>
                            <label className="custom-control-label" htmlFor="Trading-Account">Trading Account</label>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="custom-control custom-checkbox">
                            <input type="checkbox" className="custom-control-input" id="Both" name="Both" value={demat_trading_both_account} onChange={handleBothAccount}></input>
                            <label className="custom-control-label" htmlFor="Both">Both</label>
                          </div>

                        </div>
                      </div>
                      <div className="form-row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor="reasonclose-from">Please mention Reason To close your Account:</label>
                            <textarea className="form-control" rows="3" id="reasonclose-from" value={reason_for_closing} onChange={handleReasonCloseAccount}></textarea>
                          </div>
                        </div>
                      </div>

                      <div className="form-row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <button type="button" className="btn btn-lg Login-Button" onClick={() => clicksubmitaccount()}>Submit</button>
                          </div>
                        </div>
                      </div>

                      {/* <div className="form-row">
                    <div className="col-md-6">
                    <div className="form-group">
                      <label for="inputEmail4">Enter your Name</label>
                      <input type="text" className="form-control" id="name" placeholder="Name"></input>
                    </div>
                    </div>
                    <div className="col-md-6">
                    <div className="form-group">
                      <label for="inputPassword4">Enter your Registered Mobile No.</label>
                      <input type="number" className="form-control" id="number" placeholder="Mobile No"></input>
                    </div>
                  </div>
                  </div>
                  <div className="form-row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label for="inputEmail4">Enter your Registered Email</label>
                      <input type="email" className="form-control" id="inputEmail4" placeholder="Email"></input>
                    </div>
                    </div>
                    <div className="col-md-6">
                    <div className="form-group">
                    <button type="submit" className="btn  Login-Button">Submit</button>
                    </div>
                    </div>
                  </div>
                 <div className="col-md-12">
                    <div className="form-group">
                    <button type="submit" className="btn  Login-Button">Submit</button>
                    </div>
                    </div> */}
                    </form>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </>
  );
}
export default AccountClosureOption;
